import PropTypes from 'prop-types';
import React from 'react';
import ScrollIntoViewElement from '@99designs/react-components/components/ScrollIntoViewElement';
import Comment from './Comment';

export default class CommentList extends React.Component {
    constructor() {
        super();
        this.commentListItem = this.commentListItem.bind(this);
    }

    render() {
        return (
            <div className="comment-list">
                {this.getVisibleComments().map(this.commentListItem)}
            </div>
        );
    }

    getVisibleComments() {
        return this.props.comments.filter(comment => {
            // exclude pending annotation comment from the list
            return !!comment.id || !comment.annotation;
        });
    }

    commentListItem(comment, i) {
        const isSelected =
            this.props.selectedComment && comment && this.props.selectedComment.id === comment.id;

        let status = isSelected ? this.props.selectedCommentStatus : null;

        if (status === 'editing' && !this.props.canShowCommentEditing) {
            status = null;
        }

        return (
            <div key={comment.id} className="comment-list__item">
                <ScrollIntoViewElement
                    isEnabled={isSelected}
                    scrollingTrigger={isSelected}
                    scrollingContainer={document.getElementById('fullscreenSidebar')}
                >
                    <Comment
                        design={this.props.design}
                        comment={comment}
                        hasExtraPadding={true}
                        status={status}
                        isSelected={isSelected}
                        commentLocation="pane"
                        isEditable={!!comment.links.edit}
                    />
                </ScrollIntoViewElement>
            </div>
        );
    }
}

CommentList.propTypes = {
    design: PropTypes.object.isRequired,
    canShowCommentEditing: PropTypes.bool,
    comments: PropTypes.array,
    selectedComment: PropTypes.object,
    selectedCommentStatus: PropTypes.oneOf(['creating', 'editing', 'saving', 'deleting', 'error']),
};

CommentList.defaultProps = {
    canShowCommentEditing: false,
    comments: [],
};



// WEBPACK FOOTER //
// ./~/@99designs/ddo/components/CommentList.jsx